import { createTheme, Theme } from '@mui/material/styles';
import type { PaletteMode } from '@mui/material';
import { colors, darkColors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { shadows } from './shadows';
import { components } from './components';

/**
 * Creates the unified MELP Mail theme
 * Based on Google Material Design
 */
export function createMelpTheme(mode: PaletteMode = 'light'): Theme {
  const palette = mode === 'dark' ? darkColors : colors;

  return createTheme({
    palette: {
      mode,
      primary: {
        main: palette.primary.main,
        light: palette.primary.light,
        dark: palette.primary.dark,
        contrastText: palette.primary.contrastText,
      },
      secondary: {
        main: palette.secondary.main,
        light: palette.secondary.light,
        dark: palette.secondary.dark,
        contrastText: palette.secondary.contrastText,
      },
      success: {
        main: palette.success.main,
        light: palette.success.light,
        dark: palette.success.dark,
        contrastText: palette.success.contrastText,
      },
      warning: {
        main: palette.warning.main,
        light: palette.warning.light,
        dark: palette.warning.dark,
        contrastText: palette.warning.contrastText,
      },
      error: {
        main: palette.error.main,
        light: palette.error.light,
        dark: palette.error.dark,
        contrastText: palette.error.contrastText,
      },
      info: {
        main: palette.info.main,
        light: palette.info.light,
        dark: palette.info.dark,
        contrastText: palette.info.contrastText,
      },
      background: {
        default: palette.background.default,
        paper: palette.background.paper,
      },
      text: {
        primary: palette.text.primary,
        secondary: palette.text.secondary,
        disabled: palette.text.disabled,
      },
      divider: palette.divider,
      grey: palette.grey,
    },
    typography: {
      fontFamily: typography.fontFamily,
      fontSize: typography.fontSize,
      fontWeightLight: typography.fontWeightLight,
      fontWeightRegular: typography.fontWeightRegular,
      fontWeightMedium: typography.fontWeightMedium,
      fontWeightBold: typography.fontWeightBold,
      h1: typography.h1,
      h2: typography.h2,
      h3: typography.h3,
      h4: typography.h4,
      h5: typography.h5,
      h6: typography.h6,
      subtitle1: typography.subtitle1,
      subtitle2: typography.subtitle2,
      body1: typography.body1,
      body2: typography.body2,
      button: typography.button,
      caption: typography.caption,
      overline: typography.overline,
    },
    spacing,
    shadows: shadows as any, // MUI expects a Shadows type but our const array works
    shape: {
      borderRadius: 8,
    },
    components,
  });
}

/**
 * Pre-created theme instance for convenience
 */
export const melpTheme = createMelpTheme();
